import {FormControl} from '@angular/forms';

export function compare(otherControlName: string, greaterThan) {

  let thisControl: FormControl;
  let otherControl: FormControl;

  return function matchOtherValidate(control: FormControl) {
    if (!control.parent) {
      return null;
    }
    if (!thisControl) {
      thisControl = control;
      otherControl = control.parent.get(otherControlName) as FormControl;
      otherControl.valueChanges.subscribe(() => {
        thisControl.updateValueAndValidity();
      });
    }
    if (otherControl.value && !greaterThan) {
      if (otherControl.value < thisControl.value) {
        return {
          lessThan: true
        };
      }
    }
    if (otherControl.value && greaterThan && (thisControl.value || thisControl.value === 0)) {
      if (otherControl.value > thisControl.value) {
        return {
          lessThan: true
        };
      }
    }
    return null;
  };

}

export enum applicationStatus {
  LOAN_DETAILS,
  USER_BASIC_DETAILS,
  RESIDENCE_DETAILS,
  CIBIL_APPLIED,
  CIBIL_PROGRESS,
  CIBIL_APPROVED,
  CUSTOMER_INIT,
  PAYMENT_DONE,
  ENACH_ENABLED,
  APPLICATION_SUBMITTED,
  DISBURSED,
  REJECTED,
  CANCELLED,
  CREDIT_REFUSED,
  SALES_REFUSED
}
